export class FeatureNotEnabledError extends Error {
  static create(errorMessage) {
    return new FeatureNotEnabledError(errorMessage)
  }
}
